
const ReportTypes = {
    Apps: "apps3",
    AppsPlacements: "apps4",
    Date: "Date2",
    Country: "Country2",
    CountryPlacement: "Country4",
    Advertiser: "advertiser5",
    Placement: "Placement1",
    PlacementCountry: "placement_country"
}

export default ReportTypes;



// WEBPACK FOOTER //
// ./src/components/Revenue/ReportTypes.js